const prevCurv = document.getElementById('curvedPrev')
const nextCurv = document.getElementById('curvedNext')
const curvedContainer = document.getElementById('curvedSliderContainer')
const curvedSlide = document.getElementsByClassName('curvedSlides')
const curvedImages = document.querySelector('#curvedImagesList').getAttribute('data-images').split(',')
const curvedLinks = document.querySelector('#curvedImagesList').getAttribute('data-link').split(',')
const curvedAmount = curvedImages.length - 1
const curvedImg = []
const hiddenImgs = []
const prevImgs = []
const nextImgs = []


function changeSlide(event) {
  let id = event.target.id
  let direction
  let animation
  id !== 'curvedPrev' ? direction = -1 : direction = 1
  direction == 1 ? animation = 'nextSlide' : animation = 'prevSlide'

  let cslide = document.getElementsByClassName('curvedImg')
  let newPrev = []
  let newSlides = []
  let newNext = []

  Array.from(curvedSlide).forEach((slide, i) => {
    let cuim = cslide[i].getAttribute('cuim')
    let ind
    let p
    let n

    slide.classList.contains('nextSlide') ? slide.classList.remove('nextSlide') : null
    slide.classList.contains('prevSlide') ? slide.classList.remove('prevSlide') : null
    slide.classList.add(animation)

    // what happens here
    if ((parseInt(cuim) + direction) > (curvedImg.length - 1)) {
      ind = 0
    } else if (parseInt(cuim) + (direction) < 0) {
      let len = curvedImg.length
      let newIn = len - 1
      ind = newIn
    } else {
      ind = (parseInt(cuim) + direction)
    }

    // what happens here
    if ((parseInt(cuim) + direction) > (prevImgs.length - 1)) {
      p = prevImgs.length - 1
    } else if (parseInt(cuim) + (direction) < 0) {
      let len = prevImgs.length
      let newIn = len - 2
      p = newIn
    } else {
      p = (parseInt(cuim) + direction) - 1
      p < 0 ? p = prevImgs.length - 1 : null
    }

    // what happens here
    if ((parseInt(cuim) + direction) > (nextImgs.length - 1)) {
      let v = (parseInt(cuim) + direction) + 1
      v == (nextImgs.length + 1) ? n = 1 : n = 0
    } else {
      let v = (parseInt(cuim) + direction) + 1
      v > (nextImgs.length - 1) ? n = 0 : n = (parseInt(cuim) + direction) + 1
    }

    // updates the slides arrays
    newPrev.push(prevImgs[p])
    newSlides.push(curvedImg[ind])
    newNext.push(nextImgs[n])
  })

  // slide HTML get totally reset
  Array.from(curvedSlide).forEach((slide, i) => {
    slide.innerHTML = ''
  })

  Array.from(curvedSlide).forEach((slide, i) => {
    newNext[i].classList.contains('firstSlide') ? newNext[i].classList.remove('firstSlide') : null
    newSlides[i].classList.contains('firstSlide') ? newSlides[i].classList.remove('firstSlide') : null
    newPrev[i].classList.contains('firstSlide') ? newPrev[i].classList.remove('firstSlide') : null
    newNext[i].classList.contains('lastSlide') ? newNext[i].classList.remove('lastSlide') : null
    newSlides[i].classList.contains('lastSlide') ? newSlides[i].classList.remove('lastSlide') : null
    newPrev[i].classList.contains('lastSlide') ? newPrev[i].classList.remove('lastSlide') : null

    if (i == 0) { // it's the first one
      newNext[i].classList.add('firstSlide')
      newSlides[i].classList.add('firstSlide')
      newPrev[i].classList.add('firstSlide')
    }

    if (i == curvedSlide.length - 1) { // it's the last one
      newNext[i].classList.add('lastSlide')
      newSlides[i].classList.add('lastSlide')
      newPrev[i].classList.add('lastSlide')
    }
    // add the new slides to the DOM
    slide.appendChild(newNext[i])
    slide.appendChild(newSlides[i])
    slide.href = newSlides[i].getAttribute('href')
    slide.appendChild(newPrev[i])
  })

  Array.from(document.getElementsByClassName('curvedImg')).forEach(slide => {
    slide.classList.contains('curvedImgA') ? slide.classList.remove('curvedImgA') : null
    slide.classList.add('curvedImgA')
  })

  Array.from(document.getElementsByClassName('prevImg')).forEach(slide => {
    slide.classList.contains('prevImgA') ? slide.classList.remove('prevImgA') : null
    direction == 1 ? slide.classList.add('prevImgA') : null
  })

  Array.from(document.getElementsByClassName('nextImg')).forEach(slide => {
    slide.classList.contains('nextImgA') ? slide.classList.remove('nextImgA') : null
    direction == -1 ? slide.classList.add('nextImgA') : null
    direction == -1 ? slide.classList.add('lastSlideAn') : null
  })
}

prevCurv.addEventListener('click', (event) => { changeSlide(event) })
nextCurv.addEventListener('click', (event) => { changeSlide(event) })

if (curvedAmount > 0) {
  for (let i = 0; i < curvedAmount; i++) {
    let img = document.createElement('IMG')
    let p = document.createElement('IMG')
    let n = document.createElement('IMG')
    let curDiv = document.createElement('A')
    let prevDiv = document.createElement('DIV')
    let nextDiv = document.createElement('DIV')

    curDiv.setAttribute('cuim', `${i}`)
    curDiv.className = 'curvedImg'
    img.src = `${curvedImages[i]}`
    img.setAttribute('data-link', curvedLinks[i])
    curDiv.appendChild(img)
    curDiv.href = curvedLinks[i]

    prevDiv.setAttribute('cuim', `${i - 1}`)
    prevDiv.className = 'prevImg'
    p.src = `${curvedImages[i]}`
    prevDiv.appendChild(p)

    nextDiv.setAttribute('cuim', `${i + 1}`)
    nextDiv.className = 'nextImg'
    n.src = `${curvedImages[i]}`
    nextDiv.appendChild(n)

    curvedImg.push(curDiv)
    prevImgs.push(prevDiv)
    nextImgs.push(nextDiv)
  }
}


Array.from(curvedSlide).forEach((slide, i) => {
  let pin
  let nin
  i - 1 < 0 ? pin = prevImgs.length - 1 : pin = i - 1
  i + 1 > nextImgs.length ? nin = nextImgs.length - 1 : nin = i + 1

  i == curvedSlide.length - 1 ? null : null

  if (i == 0) {
    nextImgs[nin].classList.add('firstSlide')
    curvedImg[i].classList.add('firstSlide')
    prevImgs[pin].classList.add('firstSlide')
  }

  if (i == curvedSlide.length - 1) {
    nextImgs[nin].classList.add('lastSlide')
    curvedImg[i].classList.add('lastSlide')
    prevImgs[pin].classList.add('lastSlide')
  }

  slide.appendChild(nextImgs[nin])
  slide.appendChild(curvedImg[i])
  slide.appendChild(prevImgs[pin])
})

if (curvedImg.length > curvedSlide.length) {
  let amount = curvedSlide.length
  do {
    hiddenImgs.push(curvedImg[amount])
    amount++
  } while (amount < curvedImg.length)
}
